module.exports = __webpack_public_path__ + "static/basic-babcb01620f0fb26f4316ce238d1bc13.png";